module.exports = __webpack_public_path__ + "img/Radiobtn_check.38ddda16.svg";